if (!customElements.get("cart-note")) {
  class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener(
        "keyup",
        debounce(this.onChangeHandler.bind(this), 300)
      );
      this.input = this.querySelector("#cart-note");
      this.textArea = this.querySelector(".cart-note__textarea");

      if (this.input && this.textArea) {
        this.input.addEventListener("change", this.toggleNote.bind(this));
      }
      if(this.textArea.value != '') {
        this.input.checked = true
      }
    }
   
    toggleNote() {
      this.textArea.classList.toggle("expanded");
      if(this.textArea.value != '') {
        this.input.checked = true
      }
    }
    onChangeHandler() {
      const body = JSON.stringify({
        note: this.querySelector("textarea").value,
      });

      return fetch(routes.cart_update_url, {
        ...fetchConfig(),
        ...{ body },
      }).then((response) => response.json);
    }
  }

  customElements.define("cart-note", CartNote);
}
